let materialIconsPromise = null;

// A fonte é necessária apenas quando um layout configurado no CMS usa
// `type: 'mi'`. Mantê-la fora da folha crítica evita uma dependência externa
// em páginas que não exibem Material Icons.
export function ensureMaterialIcons() {
  if (!materialIconsPromise) {
    materialIconsPromise = import('@ep/styles/components/icons/materialIcons.scss').catch((error) => {
      materialIconsPromise = null;
      throw error;
    });
  }
  return materialIconsPromise;
}
